import type { Company } from "types/company";
import type { Package } from "types/package";
import {
  findPackageByDetailId,
  packageIsIndividual,
} from "pages/companies/register/registerPackageUtils";
import { isIndividualAccount } from "utils/accountType";

export type ResolveIndividualOptions = {
  company?: Pick<Company, "isIndividual" | "packageId"> | null;
  packages: Package[];
  /** Account enrollment row id (PACKAGE_DETAIL id). */
  packageDetailsId?: string | number | null;
};

/**
 * True when the account is individual: company flag and/or enrolled package detail.
 */
export function resolveIsIndividualAccount(
  options: ResolveIndividualOptions
): boolean {
  const { company, packages, packageDetailsId } = options;

  if (isIndividualAccount(company)) return true;

  const detailRefs = [
    packageDetailsId,
    company?.packageId,
    (company as { packageDetailsId?: string | number })?.packageDetailsId,
  ].filter((v) => v != null && v !== "");

  for (const ref of detailRefs) {
    const match = findPackageByDetailId(packages, ref);
    if (match && packageIsIndividual(match.pkg)) return true;
  }

  const pkgId = company?.packageId;
  if (pkgId != null && pkgId !== "" && packages.length > 0) {
    const byPackageId = packages.find((p) => String(p.id) === String(pkgId));
    if (byPackageId && packageIsIndividual(byPackageId)) return true;
  }

  return false;
}
